import { Avatar, Button, Chip, Stack, Typography } from "@mui/material";
import React, { useRef } from "react";
import { APP_ICONS } from "../../assets";
import AppContainer from "../../components/containers/AppContainer";
import SuspendDialog from "../../components/dialog/SuspendDialog";
import { updateVendorProfile } from "../../services/Profile";
import { constants } from "../../theme/Variables";

const StoreProfile = ({ data, fetchVendorsDetails, state, setIsLoading }) => {
  const openSuspendDialog = useRef();
  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };
  const handleSuspendVendor = async () => {
    try {
      let payload = {
        status: "InActive",
      };
      setIsLoading(true);
      const response = await updateVendorProfile(state?._id, payload);
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        handleOpenSnackBar("success", response?.data?.message);
        openSuspendDialog.current.closeDialog();
        fetchVendorsDetails();
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      console.log(error, "errorerrorerrorerror");
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppContainer
        styleProps={{
          p: 2,
          borderRadius: "6px",
        }}
      >
        <Stack alignItems={"center"} gap={1}>
          <Avatar
            src={data?.StoreLogo}
            sx={{
              height: 88,
              width: 88,
            }}
          />
          <Typography fontSize={"1.375rem"} fontWeight={500}>
            {data?.StoreName}
          </Typography>
          <Chip
            label={data?.storeCategory}
            sx={{
              borderRadius: "8px",
              backgroundColor: "customColor.moonRaker",
              color: "primary.main",
              fontWeight: 600,
            }}
          />
          <Button
            variant="suspend_button"
            sx={{ mt: 3 }}
            endIcon={<img src={APP_ICONS.warningIcon} width={22} />}
            onClick={() => {
              openSuspendDialog.current.openDialog({
                warningText: "Are You Sure You Want To Suspend This Store?",
              });
            }}
          >
            Suspend Store
          </Button>
        </Stack>
      </AppContainer>
      <SuspendDialog
        ref={openSuspendDialog}
        handleSuspend={handleSuspendVendor}
      />
    </>
  );
};

export default StoreProfile;
